module.exports = __webpack_public_path__ + "static/media/PCR_product_X.f4ae1b5f.svg";